import React from "react";
const HomePage = () => {
  return (
    <div>
      <h1>Welcome TO our Home Page</h1>
    </div>
  );
};

export default HomePage;
